import { render } from "./Flash.vue?vue&type=template&id=e81057c2"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"
script.render = render

export default script